import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';
import { IActivationMutation } from '../../models/activation.model';
import { RootState } from '../store';
import { activationApi } from '../api/activation';
import { brandEmptyValue } from '../../components/atoms/brand-field-array';

export interface INewActivationState {
    mutation: IActivationMutation;
}

export const initialState: INewActivationState = {
    mutation: {
        activationId: null,
        step: 1,
        productsCount: 0,
        packagesCount: 0,
        packageId: '',
        cost: '',
        totalCost: '',
        type: '',
        templateId: '',
        chiefReview: '',
        name: '',
        displayName: '',
        concept: '',
        focus: '',
        comment: '',
        isTaxableReward: '',
        customGroup: '',
        divisionIds: [],
        categoryIds: [],
        brands: [brandEmptyValue],
        clubIds: [],
        tasks: [],
        isReactivation: false,
        activationIds: [],
        includedProducts: '',
        submitForVerification: false,
        mode: 'new',
        products: [],
    },
};

export const newActivationSlice = createSlice({
    name: 'newActivation',
    initialState,
    reducers: {
        setNewActivationValues: (state, { payload }: PayloadAction<IActivationMutation>) => {
            state.mutation = { ...state.mutation, ...payload };
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            isAnyOf(
                activationApi.endpoints.saveActivation.matchFulfilled,
                activationApi.endpoints.updateActivation.matchFulfilled
            ),
            (state, action) => {
                const { payload } = action;

                if (!payload.availableActions.edit) {
                    state.mutation = initialState.mutation;
                }
            }
        );
    },
});

export default newActivationSlice.reducer;

export const { setNewActivationValues } = newActivationSlice.actions;

export const selectActivationState = (state: RootState) => state.activation;
